import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {catchError, finalize} from 'rxjs/operators';
import {EventsFlowService as EventsFlowApiService} from '../../api/services/events-flow.service';
import {GetEventsFlowListRequest} from '../../api/models/get-events-flow-list-request';
import {GetEventsFlowListResponse} from '../../api/models/get-events-flow-list-response';
import {EventsFlowModel} from '../../api/models/events-flow-model';


export class EventsFlowDatasource implements DataSource<EventsFlowModel> {

  constructor(private eventsFlowApiService: EventsFlowApiService,) {
  }

  private dataSubject = new BehaviorSubject<EventsFlowModel[]>([]);
  private dataTotalSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(true);

  public loading$ = this.loadingSubject.asObservable();
  public dataCount$ = this.dataTotalSubject.asObservable();

  connect(collectionViewer: CollectionViewer): Observable<EventsFlowModel[] | ReadonlyArray<EventsFlowModel>> {
    console.log('Connecting data source');
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    console.log('Disconnecting data source');
    this.dataSubject.complete();
    this.loadingSubject.complete();
    this.dataTotalSubject.complete();
  }

  public currentPageData(): EventsFlowModel[] {
    return this.dataSubject.getValue();
  }

  public queryData(state: GetEventsFlowListRequest): void {
    console.log('query audit items');
    this.loadingSubject.next(true);

    this.eventsFlowApiService
      .eventsFlowGetEventsFlowList({body: state})
      .pipe(
        catchError(() => of({data: [], total: 0})),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe((response: GetEventsFlowListResponse) => {
        this.dataTotalSubject.next(response.total);
        this.dataSubject.next(response.data);
      });
  }
}
